<template>
<div class="container v-content-container">
    <div class="row">
        <div class="col-xs-12">
            <h1>
                <i class="fa fa-fw fa-lg fa-home"></i>{{ $label('operator.operator') }}: {{ operatorName }}
                <a @click="createOperator" class="btn btn-v-lightgreen-white pull-right" data-toggle="tooltip" data-playement="top" title="Neuen Betreiber anlegen">
                    <i class="fa fa-fw fa-lg fa-plus"></i>
                </a>
                <select v-model="selectedOperatorId" class="form-control course-select pull-right" style="margin-right: 15px;">
                    <option v-for="operator in operators.data" :value="operator.id">{{ operator.name }}</option>
                </select>
            </h1>
        </div>
    </div>

    <navigation-tabs :operator-id="selectedOperatorId"></navigation-tabs>

    <div v-show="loading" class="row">
        <div class="col-xs-12">
            <view-loader margin-top-pixels="15"></view-loader>
        </div>
    </div>

    <div v-show="!loading" class="row">
        <div class="col-sm-6">
            <company-details :operator-id="selectedOperatorId" :updating="updating"></company-details>
        </div>

        <div class="col-sm-6 tooltip-wrapper">
            <operator-address :operator-id="selectedOperatorId" :updating="updating"></operator-address>
        </div>
    </div>

    <div v-show="!loading" class="row"><div class="col-xs-12">&nbsp;</div></div>

    <div v-show="!loading" class="row">
        <div class="col-sm-6 tooltip-wrapper">
            <contact-person :operator-id="selectedOperatorId" :updating="updating"></contact-person>
        </div>
    </div>

    <div v-show="!loading" class="row"><div class="col-xs-12">&nbsp;</div></div>
    <hr v-show="!loading">

    <div v-show="!loading" class="row">
        <div class="col-xs-offset-4 col-xs-2">
            <button @click="startUpdating" :class="{ 'is-disabled': updating }" class="btn btn-lg btn-primary btn-block">
                <span v-show="!updating"><i class="fa fa-lg fa-lg fa-save"></i> {{ $label('common.save') }}</span>
                <img v-show="updating" height="22px" :src="require('@/assets/img/loader.svg')">
            </button>
        </div>
        <div class="col-xs-2">
            <a :class="{ 'is-disabled': updating }" class="btn btn-lg btn-danger btn-block">
                <i class="fa fa-lg fa-fw fa-trash-o"></i> {{ $label('common.delete') }}
            </a>
        </div>
    </div>

    <div v-show="!loading" class="row"><div class="col-xs-12">&nbsp;</div></div>
</div>
</template>

<script>
import Api from '@/api';
import swal from 'sweetalert';
import ViewStatus from '@/mixins/ViewStatus.js';
import Alerts from '@/mixins/Alerts.js';

import ViewLoader from '@/components/ViewLoader.vue'
import NavigationTabs from '@/components/Operator/NavigationTabs.vue';
import CompanyDetails from '@/components/Operator/BaseData/CompanyDetails.vue';
import OperatorAddress from '@/components/Operator/BaseData/OperatorAddress.vue';
import ContactPerson from '@/components/Operator/BaseData/ContactPerson.vue';

export default {
    mixins: [ViewStatus, Alerts],

    components: {
        ViewLoader,
        NavigationTabs,
        CompanyDetails,
        OperatorAddress,
        ContactPerson,
    },

    data() {
        return {
            selectedOperatorId: null,
            operator: null,
            operators: [],
            //
            viewName: 'operatorBaseDetails',
            loadConfirmations: {
                'operator': {
                    timesRequired: 1,
                    timesReceived: 0,
                },
                'address': {
                    timesRequired: 1,
                    timesReceived: 0,
                },
                'phoneNumber': {
                    timesRequired: 2,
                    timesReceived: 0,
                },
                'faxNumber': {
                    timesRequired: 1,
                    timesReceived: 0,
                },
                'contactPerson': {
                    timesRequired: 1,
                    timesReceived: 0,
                },
            },

            updateConfirmations: {
                'operator': {
                    timesRequired: 1,
                    timesReceivedSuccessful: 0,
                    timesReceivedFailed: 0,
                },
                'address': {
                    timesRequired: 1,
                    timesReceivedSuccessful: 0,
                    timesReceivedFailed: 0,
                },
                'phoneNumber': {
                    timesRequired: 2,
                    timesReceivedSuccessful: 0,
                    timesReceivedFailed: 0,
                },
                'faxNumber': {
                    timesRequired: 2,
                    timesReceivedSuccessful: 0,
                    timesReceivedFailed: 0,
                },
                'contactPerson': {
                    timesRequired: 1,
                    timesReceivedSuccessful: 0,
                    timesReceivedFailed: 0,
                },
            },
        };
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.selectedOperatorId = vm.$route.params.id;
            vm.startLoading();
            vm.getOperators();
        });
    },

    beforeRouteUpdate(to, from, next) {
        this.startLoading();
        this.getOperators();
        next();
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        getOperators() {
            let endpoint = this.$partnerEndpoint('operators');

            Api().get(endpoint)
                .then((response) => {
                    this.operators = response.data;
                })
                .catch((error) => {
                    //
                });
        },

        createOperator() {
            Api().post('/partners/demo_partner/operators')
                .then((response) => {
                    this.goToOperator(response.data.data.id)
                })
                .catch((error) => {
                    //
                });
        },

        goToOperator(operatorId) {
            if (this.selectedOperatorId !== operatorId) {
                this.selectedOperatorId = operatorId;
            }

            this.$router.push({
                name: 'operatorBaseData',
                params: { id: operatorId }
            });
        },

        listenEvents() {
            Event.$on(this.everythingUpdatedSuccessfulEventName, () => {
                this.successAlert('Success!', 'Operator details updated.');
            });
        },
    },

    computed: {
        operatorName() {
            if (typeof this.operators.data === 'undefined' || this.operators.data.length < 1 || !this.selectedOperatorId) {
                return '-';
            }

            for (var i = 0; i < this.operators.data.length; i++) {
                if (this.operators.data[i].id == this.selectedOperatorId) {
                    return this.operators.data[i].name;
                }
            }

            return '-';
        },
    },

    watch: {
        selectedOperatorId(selectedOperatorId, oldSelectedOperatorId) {
            if (oldSelectedOperatorId) {
                this.resetLoadConfirmations();
                this.resetUpdateConfirmations();
            }

            if (!selectedOperatorId) {
                return;
            }

            this.goToOperator(selectedOperatorId)
        }
    }
}
</script>
